import React from 'react';
import {
  focusEditor,
  isMarkActive,
  toggleMark,
  useEventPlateId,
  useEditorState,
} from '@udecode/plate-common';

import { ToolbarButton } from './ToolbarButton';

/**
 * Toolbar button to toggle the mark of the leaves in selection.
 */
export const MarkToolbarButton = ({
  id,
  type,
  clear,
  ...props
}) => {
  const editor = useEditorState(useEventPlateId(id));
  return (
    <ToolbarButton
      active={!!editor?.selection && isMarkActive(editor, type)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        toggleMark(editor, { key: type, clear });
        setTimeout(() => {
          focusEditor(editor);
        }, 0);
      }}
      {...props}
    />
  );
};